import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "messages-container",
  id: "messages-container"
}
const _hoisted_2 = {
  class: /*@__PURE__*/_normalizeClass('message-createdAt')
}
const _hoisted_3 = { class: "order-2 main-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.chatType === 'OBJECT')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(`d-flex justify-${
                        message.sender.id !== _ctx.currentUser.id ? 'start' : 'end'
                    } mx-2`),
              key: message.id
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("small", null, [
                  (message.sender.id === _ctx.currentUser.id)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.getFormattedSenderName(message).name), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.getFormattedSenderName(message).separator), 1),
                        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.getDate(message.createdAt)), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.getFormattedSenderName(message).name), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.getFormattedSenderName(message).separator), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.getDate(message.createdAt)), 1)
                      ], 64))
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(
                                message.sender.id !== _ctx.currentUser.id
                                    ? 'otherMessages'
                                    : 'myMessages'
                            )
                }, _toDisplayString(message.text), 3)
              ])
            ], 2))
          }), 128))
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.filteredMessages, (message) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "d-flex pt-2 font-weight-regular message",
            style: {"color":"black"},
            key: message.id
          }, [
            (_ctx.isNotFromCurrentUser(message) || _ctx.starredOnly)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(
                        _ctx.isNotFromCurrentUser(message) || _ctx.starredOnly
                            ? 'order-1 mr-4'
                            : 'order-3 ml-4'
                    )
                }, [
                  _createVNode(_component_v_avatar, {
                    color: _ctx.getNameColor(message),
                    size: "x-small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getUserBigram(message.sender)), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"])
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("small", null, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.getFormattedSenderName(message).name), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.getFormattedSenderName(message).separator), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.getDate(message.createdAt)) + " ", 1),
                  (message.starred)
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 0,
                        location: "bottom"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_icon, _mergeProps({
                            size: "x-small",
                            ref_for: true
                          }, props, {
                            class: "mx-1",
                            color: "primary"
                          }), {
                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                              _createTextVNode(" $fa-star ")
                            ])),
                            _: 2
                          }, 1040)
                        ]),
                        default: _withCtx(() => [
                          _cache[1] || (_cache[1] = _createElementVNode("span", null, "Important!", -1))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(
                                _ctx.isNotFromCurrentUser(message)
                                    ? 'position-relative otherMessages'
                                    : 'position-relative myMessages'
                            )
                }, [
                  _createTextVNode(_toDisplayString(message.text) + " ", 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.getMessageOptionsClass(message))
                  }, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn_icon, _mergeProps({ ref_for: true }, props, {
                            icon: 
                                                    message.starred ? '$far-fa-star' : '$fa-star'
                                                ,
                            color: message.starred ? 'secondary' : 'primary',
                            onClick: ($event: any) => (_ctx.toggleMessageStar(message))
                          }), null, 16, ["icon", "color", "onClick"])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(message.starred
                                                ? "Retirer des messages importants."
                                                : "Ajouter aux messages importants."), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ], 2)
                ], 2)
              ])
            ]),
            (!_ctx.starredOnly)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(
                        _ctx.isNotFromCurrentUser(message)
                            ? 'order-3 flex-grow-1'
                            : 'order-1 flex-grow-1'
                    )
                }, null, 2))
              : _createCommentVNode("", true)
          ]))
        }), 128))
  ]))
}